import * as types from 'shared/components/NewNavbar/types';
import NextLink from 'shared/components/NextLink';

import styles from './LinkButton.module.scss';

export function LinkButton({ children, className, aTag = false, ...linkProps }: types.LinkButton): JSX.Element {
  return aTag ? (
    <a href={typeof linkProps.href === 'string' ? linkProps.href : ''} className={`${styles.button} ${className}`}>
      {children}
    </a>
  ) : (
    <NextLink {...linkProps} passHref>
      <span className={`${styles.button} ${className}`}>{children}</span>
    </NextLink>
  );
}
